import axios from 'axios';
import { authHeader } from '../_helpers';
import config from '../_helpers/_config';

export const schedulesService = {
    postSchedulesRetrieval,
    getSchedulesStatus,
    postSchedulesReset,
    postSchedulesUpdate,
    postSchedulesStop,
    deleteSchedules
};

async function postSchedulesRetrieval(projectId, deviceId) {
    return axios({
        method: 'post',
        url: `${config.API_LOCATION}/schedules/${deviceId}`,
        headers: Object.assign({ 'Current-Project': `${projectId}` }, authHeader())
    });
}

async function getSchedulesStatus(projectId, deviceId) {
  return axios({
    method: 'get',
    url: `${config.API_LOCATION}/schedules/${deviceId}`,
    headers: Object.assign({ 'Current-Project': `${projectId}` }, authHeader())
  });
}

async function postSchedulesReset(projectId, deviceId) {
  return axios({
    method: 'post',
    url: `${config.API_LOCATION}/schedules/${deviceId}/reset`,
    headers: Object.assign({ 'Current-Project': `${projectId}` }, authHeader())
  });
}

async function postSchedulesUpdate(projectId, deviceId, jsonData) {
  return axios({
    method: 'post',
    url: `${config.API_LOCATION}/schedules/${deviceId}/update`,
    headers: Object.assign({ 'Content-Type': 'application/json' }, { 'Current-Project': `${projectId}` }, authHeader()),
    data: jsonData
  });
}

async function postSchedulesStop(projectId, deviceId) {
  return axios({
    method: 'post',
    url: `${config.API_LOCATION}/schedules/${deviceId}/stop`,
    headers: Object.assign({ 'Current-Project': `${projectId}` }, authHeader())
  });
}

async function deleteSchedules(projectId, deviceId) {
  return axios({
    method: 'delete',
    url: `${config.API_LOCATION}/schedules/${deviceId}`,
    headers: Object.assign({ 'Current-Project': `${projectId}` }, authHeader())
  });
}
